import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '@src/environments/environment';

export function apiInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const auth = inject(AuthService);
  const snack = inject(MatSnackBar);

  const authReq = req.clone({
    url: environment.apiHost === 'mock' ? buildMockUrl(req.url) : req.url,
    headers: req.headers.set('Authorization', auth.token),
  });

  return next(authReq).pipe(tap({
    error: (error) => {
      if (error.status === 401) {
        auth.login();
      } else {
        const message = error.error.message || error.message;
        snack.open(message, 'Dismiss');
      }
    }
  }));
}

const buildMockUrl = (url: string) => {
  const parts = url.split('/');
  const name = parts[2] ? `${parts[1]}-id` : parts[1];
  return `/assets/mock/${name}.json`;
};
